import Vue from "vue";
import router from "../router/index"
Vue.directive("jumps",{
    bind(el,binding){
        el.onclick=()=>{
            router.push({name:binding.arg});
        }
    }
})


// WEBPACK FOOTER //
// ./src/util/jump.js